<div *ngIf="!loading && checked">
  <div class="row my-5">
    <div class="col-md-12 text-center">
      <div *ngIf="verified" class="alert alert-success" role="alert">
        <strong>{{ 'gtm_setup.verified_heading' | translate }}</strong>
        <p>{{ 'gtm_setup.verified_redirect' | translate }}</p>
      </div>
      <div *ngIf="!verified" class="alert alert-warning" role="alert">
        <strong>{{ 'gtm_setup.not_verified_heading' | translate }}</strong>
        <p>{{ 'gtm_setup.not_verified_body' | translate }}</p>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!loading && (!checked && !verified)" class="container">
  <div class="row mt-3">
    <div class="col-md-7">
      <h4>{{ 'gtm_setup.title' | translate }}</h4>
      <span>{{ 'gtm_setup.subtitle' | translate }}</span>
    </div>
    <div class="col-md-5 d-flex justify-content-end align-items-start" style="gap: 0.5rem;">
      <div class="d-flex flex-column align-items-center">
        <label for="gtmId" class="form-label mb-1">{{ 'gtm_setup.label_tag_manager' | translate }}</label>
        <input id="gtmId" type="text" [title]="'gtm_setup.title_tag_manager' | translate" class="form-control text-center"
          [ngModel]="details?.gtmId" readonly disabled />
      </div>
      <div class="d-flex flex-column align-items-center">
        <label for="gaId" class="form-label mb-1">{{ 'gtm_setup.label_analytics' | translate }}</label>
        <input id="gaId" type="text" [title]="'gtm_setup.title_analytics' | translate" class="form-control text-center"
          [ngModel]="details?.gaMeasurementId" readonly disabled />
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <div ngbAccordion>
        <div ngbAccordionItem [collapsed]="checked">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>{{ 'gtm_setup.accordion_primary' | translate }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <h6>&lt;head&gt;</h6>
                <div class="my-3 ms-5">
                  <span>{{ 'gtm_setup.snippet_gtm_head' | translate }}</span>
                  <textarea class="form-control text-muted font-monospace fs-08" [ngModel]="details?.gtmHeadHtmlTag"
                    style="height:190px;" disabled="true"></textarea>
                </div>
                <div class="my-3 ms-5">
                  <span>{{ 'gtm_setup.snippet_search_console' | translate }}</span>
                  <textarea class="form-control text-muted font-monospace fs-08"
                    [ngModel]="details?.scVerificationHtmlTag" style="height: 65px;" disabled="true"></textarea>
                </div>
                <div class="my-5">
                  <h6>&lt;body&gt;</h6>
                  <div class="my-3 ms-5">
                    <span>{{ 'gtm_setup.snippet_gtm_noscript' | translate }}</span>
                    <textarea class="form-control text-muted font-monospace fs-08" [ngModel]="details?.gtmNoScriptTag"
                      style="height:120px;" disabled="true"></textarea>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div ngbAccordionItem [collapsed]="true">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>{{ 'gtm_setup.accordion_alternate' | translate }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="my-3">
                  <span>{{ 'gtm_setup.snippet_ga4' | translate }}</span>
                  <textarea class="form-control text-muted font-monospace fs-08" [ngModel]="details?.gaHtmlTag"
                    style="height: 210px;" disabled="true"></textarea>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <ng-container *ngTemplateOutlet="verifyGtmTagButton"></ng-container>
  </div>
</div>

<ng-template #verifyGtmTagButton>
  <div class="col-md-12 d-flex justify-content-center">
    <button class="btn btn-lg btn-primary p-3" (click)="verifyGtmTag()" [disabled]="loading">
      <i class="fas fa-check-circle fa-lg"></i> {{ 'gtm_setup.button_verify' | translate }}
    </button>
  </div>
</ng-template>
